import React from 'react';
import { BrainGraph } from '../components/deck/BrainGraph';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, INK, Reveal, Title } from '../components/deck/Type';
import { ECOSYSTEM_SOURCE } from '../data/ecosystem';
type Stage = {
  angle: number;
  value: string;
  label: string;
  tone: string;
};
const STAGES: Stage[] = [{
  angle: -90,
  value: '35K+',
  label: 'Institutional LPs',
  tone: INK.blue
}, {
  angle: -30,
  value: '100K+',
  label: 'Capital organizations',
  tone: INK.blue
}, {
  angle: 30,
  value: '$5T+',
  label: 'Capital deployed',
  tone: INK.emerald
}, {
  angle: 90,
  value: '1M+',
  label: 'Venture rounds',
  tone: INK.emerald
}, {
  angle: 150,
  value: '10M+',
  label: 'Venture universe',
  tone: '#F4F7FC'
}, {
  angle: 210,
  value: '50K+',
  label: 'Venture-backed exits',
  tone: INK.gold
}];
const SIGNALS = 'Companies · Markets · Capital · Investment decisions · Valuations · Programs · Portfolio performance · Passes · Failures · Exits';
function position(angle: number, radius = 50) {
  const rad = angle * Math.PI / 180;
  return {
    left: `${50 + Math.cos(rad) * radius}%`,
    top: `${50 + Math.sin(rad) * radius}%`
  };
}
export function LifecycleSlide() {
  return <Slide index={3} source={ECOSYSTEM_SOURCE} data-id="element-165" data-mp="lxfqjaxjyz1p">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-166" data-mp="lv37eug26in2">
        <div className="max-w-[58%]" data-id="element-167" data-mp="gze4qi8qslmj">
          <Eyebrow data-id="element-168" data-mp="gw9vv7kc11pj">The venture lifecycle</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-169" data-mp="3pextp52drhvs">
            Every venture decision creates data. Almost none of it becomes
            shared intelligence.
          </Title>
        </div>
        <Caption className="max-w-[30%] text-right" data-id="element-170" data-mp="2ytp1uy4j5x9">
          Capital, companies and outcomes move in a loop — the intelligence they
          generate never returns to the ecosystem.
        </Caption>
      </div>

      <div className="relative mt-auto flex flex-1 items-center justify-center" data-id="element-171" data-mp="36md6a35ga4zd">
        <div className="relative aspect-square h-[40vh]" data-id="element-172" data-mp="31otud9w864al">
          <div className="absolute inset-[8%] rounded-full border border-dashed border-white/12" data-id="element-173" data-mp="31m7kh3lv3cp7" />

          {STAGES.map((stage, i) => <div key={stage.label} className="absolute -translate-x-1/2 -translate-y-1/2" style={position(stage.angle)} data-id="element-174" data-mp="1ajqi443f736r" data-mpi={i}>
              <Reveal delay={0.06 * i} className="w-[11vw] text-center" data-id="element-175" data-mp="1jckddaz9id69">
                <p className="text-[clamp(13px,1.55vw,32px)] leading-none" style={{
              fontFamily: 'var(--font-serif)',
              color: stage.tone
            }} data-id="element-176" data-mp="1jbslob8sczl9">
                  {stage.value}
                </p>
                <p className="mt-[0.8vh] text-[clamp(7.5px,0.78vw,16px)] uppercase tracking-[0.16em] text-[#8B95A8]" data-id="element-177" data-mp="vmho12mqflbc">
                  {stage.label}
                </p>
              </Reveal>
            </div>)}

          <div className="absolute inset-[18%] flex flex-col items-center justify-center" data-id="element-178" data-mp="2714rd14wmpit">
            <BrainGraph density={0.8} className="h-full w-full" data-id="element-179" data-mp="2c07v8i95epp7" />
          </div>
          <div className="absolute inset-x-0 top-[83%] text-center" data-id="element-180" data-mp="2m5pmjh7k2vb9">
            <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.24em] text-[#3B8CFF]" data-id="element-181" data-mp="2m70qbh10432d">
              Venture Intelligence Brain
            </span>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 max-w-[24%]" data-id="element-182" data-mp="2cda2mecp7wnq">
          <span className="text-[clamp(7.5px,0.78vw,16px)] uppercase tracking-[0.2em] text-[#9B7BFF]" data-id="element-183" data-mp="28czy764k1eaz">
            15K+ accelerators &amp; venture programs
          </span>
          <Caption className="mt-[0.8vh]" data-id="element-184" data-mp="1yf2b4lyflnjy">
            Develop companies inside the venture universe.
          </Caption>
        </div>

        <div className="absolute bottom-0 right-0 max-w-[27%] text-right" data-id="element-185" data-mp="1th0sg24x3q90">
          <p className="text-[clamp(12px,1.35vw,28px)] leading-snug text-[#F4F7FC]" style={{
          fontFamily: 'var(--font-serif)'
        }} data-id="element-186" data-mp="1pfys1hz9l85g">
            The ecosystem creates the data.
            <br data-id="element-187" data-mp="3ju9h9rjru4br" />
            StartupFuel turns it into intelligence.
          </p>
        </div>
      </div>

      <Reveal delay={0.4} className="mt-[2vh]" data-id="element-188" data-mp="3qxfwk7fmw4fw">
        <p className="text-center text-[clamp(7.5px,0.78vw,16px)] tracking-[0.14em] text-white/30" data-id="element-189" data-mp="3vv7tjfv4ygqy">
          {SIGNALS}
        </p>
      </Reveal>
    </Slide>;
}